import React from 'react';
import { useSelector } from 'react-redux';
import UserLocalizationComponent from './UserLocalizationComponent';
import { getHeaderContentData, getTenantData } from 'common/utilities/utils';
import MENUS_PLP_CONSTANTS from '../Constants/MenusPLPConstants';

const UserLocalization = () => {
  const { DISPOSITION } = MENUS_PLP_CONSTANTS;

  let segmentedHomePageData = null,
    segmentedTenantData = null;

  let userParams = useSelector(data => data.appStateReducer.userStatus);

  const allReducerData = useSelector(data => {
    return {
      homePageContent: data.contentReducer.response || null,
      tenantReducerContent: data.tenantReducer || null,
      marketPageContent: data.marketConfigReducer.response || null,
    };
  });

  if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
    const { tenant = [] } = allReducerData.marketPageContent.headerData || {};
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent) || null;
    segmentedTenantData = getTenantData(tenant);
  }

  return (
    <UserLocalizationComponent
      contentData={{
        segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
        dispositionData: segmentedTenantData,
        contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
      }}
      userParams={userParams}
      tenantReducerData={allReducerData.tenantReducerContent}
    />
  );
};

export default UserLocalization;
